import { create } from 'zustand';
import { ThemeState } from '../types/store';

interface ThemeStore extends ThemeState {
  // Actions
  setMode: (mode: 'light' | 'dark') => void;
  toggleMode: () => void;
  setHideDrawerPlaceholder: (hide: boolean) => void;
}

export const useThemeStore = create<ThemeStore>((set, get) => ({
  // Initial state
  mode: 'dark', // Default to dark mode as in original App.tsx
  hideDrawerPlaceholder: false,

  // Actions
  setMode: (mode: 'light' | 'dark') => {
    set({ mode });
  },

  toggleMode: () => {
    set((state) => ({
      mode: state.mode === 'light' ? 'dark' : 'light',
    }));
  },

  setHideDrawerPlaceholder: (hide: boolean) => {
    set({ hideDrawerPlaceholder: hide });
  },
}));
